<span class="progress__ready"></span>
